import { MenuItem, TextFieldProps } from "@material-ui/core"
import { Field } from "formik"
import { TextField } from "formik-material-ui"
import styled from "styled-components"

const Styled = {
  Field: styled(Field)<{ $hiddenLabel?: boolean }>`
    .MuiSelect-root {
      &:focus-visible {
        border: 2px dashed white;
        outline: 3px dashed #0e3487;
        outline-offset: 2px;
      }
    }

    ${(p) => p?.$hiddenLabel && `label { display: none; }`}
    width: 100%;
    .MuiFormHelperText-contained {
      margin-right: 0;
    }
    .MuiFormHelperText-root {
      font-size: 12px;
    }
    /* text alignment: */
    .MuiSelect-outlined.MuiSelect-outlined {
      text-align: initial;
    }
  `,
}

// extends BaseTextFieldProps
type CommonSelectProps<T> = TextFieldProps & {
  name: string
  label?: string
  required?: boolean
  selectValues: T[]
  map(value: T): { id: string | number; name: string }
  placeholder?: string
}

function FormikSelect<T>({
  name,
  label,
  required = false,
  selectValues,
  map,
  placeholder,
  hiddenLabel,
  ...props
}: CommonSelectProps<T>) {
  return (
    <Styled.Field
      component={TextField}
      select
      name={name}
      id={name}
      required={required}
      label={label}
      helperText={" "}
      $hiddenLabel={hiddenLabel}
      placeholder={placeholder}
      {...props}
    >
      {selectValues?.map((value, i) => {
        const { name, id } = map(value)
        return (
          <MenuItem key={i} value={id}>
            {name}
          </MenuItem>
        )
      })}
    </Styled.Field>
  )
}

export default FormikSelect
